import {
  EoFormControlConfig,
  IEoFormControlConfig
} from '../eo-form/eo-form.config';
import { IEoTableFieldProp } from './eo-table-field.component';

export interface IEoTableFieldConfig extends IEoFormControlConfig {
  type?: 'tableField';
  tableProperties?: IEoTableFieldProp[];
  formConfig?: EoFormControlConfig[];
  addButtonLabel?: string;
  addButtonStyleClass?: string;
  addButtonIcon?: string;
  clearButtonLabel?: string;
  clearButtonStyleClass?: string;
  clearButtonIcon?: string;
  editButtonStyleClass?: string;
  editButtonIcon?: string;
  deleteButtonStyleClass?: string;
  deleteButtonIcon?: string;
  formHeader?: string;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  fetchApiUrl?: string;
  submitApiUrl?: string;
  deleteApiUrl?: string;
  onSubmit?: (formData: any) => void;
  onDelete?: (selectedItem: any) => void;
}

export class EoTableFieldConfig
  extends EoFormControlConfig
  implements IEoTableFieldConfig
{
  override type?: 'tableField';
  tableProperties?: IEoTableFieldProp[];
  formConfig?: EoFormControlConfig[];
  addButtonLabel?: string;
  addButtonStyleClass?: string;
  addButtonIcon?: string;
  clearButtonLabel?: string;
  clearButtonStyleClass?: string;
  clearButtonIcon?: string;
  editButtonStyleClass?: string;
  editButtonIcon?: string;
  deleteButtonStyleClass?: string;
  deleteButtonIcon?: string;
  formHeader?: string;
  submitButtonLabel?: string;
  submitButtonStyleClass?: string;
  submitButtonIcon?: string;
  fetchApiUrl?: string;
  submitApiUrl?: string;
  deleteApiUrl?: string;
  onSubmit?: (formData: any) => void;
  onDelete?: (selectedItem: any) => void;

  constructor();
  constructor(obj: IEoTableFieldConfig);
  constructor(obj?: IEoTableFieldConfig) {
    super(obj as IEoFormControlConfig);

    this.type = 'tableField';
    this.tableProperties = obj?.tableProperties ?? [];
    this.formConfig = obj?.formConfig;
    this.label = obj?.label ?? '';
    this.formHeader = obj?.formHeader;
    this.addButtonIcon = obj?.addButtonIcon ?? 'pi pi-plus';
    this.addButtonLabel = obj?.addButtonLabel ?? 'Προσθήκη';
    this.addButtonStyleClass = obj?.addButtonStyleClass ?? 'p-button-outlined';
    this.clearButtonIcon = obj?.clearButtonIcon ?? 'pi pi-times';
    this.clearButtonLabel = obj?.clearButtonLabel ?? 'Καθαρισμός';
    this.clearButtonStyleClass =
      obj?.clearButtonStyleClass ?? 'p-button-outlined p-button-danger';
    this.editButtonIcon = obj?.editButtonIcon ?? 'pi pi-pencil';
    this.editButtonStyleClass =
      obj?.editButtonStyleClass ?? 'p-button-text p-button-warning';
    this.deleteButtonIcon = obj?.deleteButtonIcon ?? 'pi pi-trash';
    this.deleteButtonStyleClass =
      obj?.deleteButtonStyleClass ?? 'p-button-text p-button-danger';
    this.submitButtonLabel = obj?.submitButtonLabel ?? 'Υποβολή';
    this.submitButtonStyleClass = obj?.submitButtonStyleClass;
    this.submitButtonIcon = obj?.submitButtonIcon;
    this.submitApiUrl = obj?.submitApiUrl;
    this.fetchApiUrl = obj?.fetchApiUrl;
    this.deleteApiUrl = obj?.deleteApiUrl;
    this.onSubmit = obj?.onSubmit;
    this.onDelete = obj?.onDelete;
  }
}
